import axios from 'axios';
import React, { useState } from 'react';
import { Card, ListGroup, ListGroupItem,Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import useAuth from '../../Hooks/useAuth';
import profile from './profile.png'
const ProfileDetail = () => {
    const {user,SignoutHandler } = useAuth()
    

    const {displayName,email,photoURL} = user;

    const [person,setPerson]=useState({})
  // products to be rendered on the UI
 // console.log(user);
 const Url= `https://damp-sands-37964.herokuapp.com/usersOutput`;

 axios.get(Url).then(res => {
  //console.log(res);
if (email) {
  const thisUser= res.data.find(userdata => userdata.email === email  )
  setPerson(thisUser);
  
 
}
})
.catch(function (error) {
  console.log(error);
})
.then(function () {
  // always executed
});  
const {name,ph,address1,address2,city,zip} = person ;

    return (
        <div>
            <Card >
   
  <Card.Img variant="top" className='mx-auto mt-4'  src={photoURL? photoURL : profile } style={{height:'155px',width:'155px',borderRadius:"100%"}} />
  <Card.Body>
    <Card.Title>Name: {displayName}</Card.Title>
    <Card.Text>
    Problems :- {address2}
    </Card.Text>
  </Card.Body>
  <ListGroup className="list-group-flush">
    <ListGroupItem>Email:{email}</ListGroupItem>
    <ListGroupItem>Phone No: {ph} </ListGroupItem>
    <ListGroupItem>Address:{address1}</ListGroupItem>
    <ListGroupItem>City:{city}</ListGroupItem>
    <ListGroupItem>ZIP:{zip}</ListGroupItem>
  </ListGroup>
  <Card.Body>
  <Card.Body>
           <Button onClick={SignoutHandler} className="btn btn-dark">Sign Out</Button>
           <Button className="btn btn-dark ms-2">Detail</Button>
            
          </Card.Body>
  </Card.Body>
</Card>
        </div>
    );
};

export default ProfileDetail;